/*****새로운 툴 추가시 처리 방법*****
    1. toolkits에 항목 추가
    2. 툴정보 저장 키, 값 추가
*/

const defaultToolkitInfoData = {
    toolkits: [
        { "name": "stopwatch", "isInclude": false },
        { "name": "timer", "isInclude": true },
        { "name": "dice", "isInclude": true },
        { "name": "coin", "isInclude": true },
        { "name": "random", "isInclude": true },
        { "name": "wheel", "isInclude": true },
        { "name": "memo", "isInclude": true },
        { "name": "whistler", "isInclude": true },
        { "name": "noisemonitor", "isInclude": true },
        { "name": "qrcode", "isInclude": true },
        { "name": "clock", "isInclude": true },
        { "name": "crayon", "isInclude": true },
        { "name": "board", "isInclude": true },
        { "name": "classthermo", "isInclude": true },
        { "name": "scoreboard", "isInclude": true },
        { "name": "video", "isInclude": true },
        { "name": "nationalrite", "isInclude": true },
        { "name": "seatswapper", "isInclude": true },
        { "name": "digitaledutool", "isInclude": true },
        { "name": "air", "isInclude": true },
        { "name": "checklist", "isInclude": true },
        { "name": "marble", "isInclude": true },
        { "name": "tournament", "isInclude": true },
        { "name": "dday", "isInclude": true },
        { "name": "note", "isInclude": true },
        { "name": "classduty", "isInclude": true },
    ],
    toolbarAutoHide: false,
    toolLayerAutoHide: false,
    toolbarPosition: "bottom",
    toolOpenMode: "toolkit", //수업도구 열기 방식(toolkit: 툴킷에서 열기, window: 새 창으로 열기)
    boardAutoSave: true, //판서 자동저장 on/off기능추가로 추가
    usernameHide: true, //닉네임 숨김 기능 추가로 추가(기본값 false ->true 20260210)
    tonlyAll: false, //선생님 맞춤 기능 추가로 추가
    randomPresetOrder: false, //선생님 맞춤 기능 - 뽑기 순서 미리 지정 기능 추가로 추가
    toolbarStyle: 'icon', //수업도구바 스타일(icon:기본, text)
    selectBg: "#F1F1F2",
    staticBg: false, //고정 배경 지정 기능 추가로 추가
    staticBgInit: null, //고정 배경 지정 기능 초기 설정 여부(설정시 true로 변경)
    stopwatch: null,
    timer: null,
    dice: null,
    coin: null,
    random: null,
    wheel: null,
    memo: null,
    memos: [], //메모리스트기능추가로 추가
    whistler: null,
    noisemonitor: null,
    qrcode: null,
    qrcodes: [], //qrcode 리스트기능추가로 추가
    qrcodeBookmark: [], //qrcode 리스트기능추가로 추가
    clock: null,
    crayon: null,
    board: null,
    boards: [], //판서리스트기능추가로 추가
    classthermo: null,
    random_data: null,
    wheel_data: null,
    crayon_data: null,
    board_data: null,
    noisemonitor_data: null, //민감도 설정추가
    timer_data: null, //제목, 효과음 설정 저장 추가
    originImage: null,
    originImageSeq: null,
    thumbImage: null,
    thumbImageSeq: null,
    bgm: null,
    effect: null,
    customBgm: null,
    customEffect: null,
    bookmarkBgm: null,
    bookmarkEffect: null,
    suggestionList: null, //제안및문의 답변 알림히스토리 저장 데이타 추가
    scoreboard: null, //점수판 추가
    scoreboard_data: null, //점수판 데이타 추가
    video: null, //영상재생 추가
    videos: [], //영상재생 데이타 추가
    clock_data: null, //시계 기능추가로 데이타 추가
    toolOrder: null, //수업도구바 순서 변경 기능추가로 데이타 추가
    movedTools: null, //위치이동한 툴 저장체크로 추가
    nationalrite: null, //국민의례 추가
    nationalrite_data: null, //국민의례 데이타 추가
    seatswapper: null, //자리바꾸기 추가로 데이타 추가
    seatswapper_data: null, //자리바꾸기 추가로 데이타 추가
    seatswapperPresetOrder: true, //선생님 맞춤 기능 - 자리바꾸기 자리 미리 지정 기능 추가로 추가
    scoreAutoSave: true, //점수판 자동저장 on/off기능추가로 추가
    air: null, //미세먼지측정기 추가로 추가
    air_data: null, //미세먼지측정기 추가로 추가
    digitaledutool: null, //디지털교구모음 추가로 추가
    digitaledutool_data: null, //디지털교구모음 추가로 추가
    checklist: null, //체크리스트 추가로 추가
    checklist_data: null, //체크리스트 추가로 추가
    marble: null, //뽑기레이스 추가로 추가
    marble_data: null, //뽑기레이스 추가로 추가
    tournament: null, //대진표 추가로 추가
    tournament_data: null, //대진표 추가로 추가
    dday: null, //dday 추가로 추가
    dday_data: null, //dday 추가로 추가
    note: null,
    note_data: null,
    classduty: null,
    classduty_data: null,
};

export default defaultToolkitInfoData;
